<template>
  <div class="py-1">
    <input
      type="checkbox"
      :id="name"
      :name="name"
      :placeholder="label"
      :class="{
        danger: useForm && $parent.form.errors.has(name),
      }"
      :value="value"
      @input="emit"
      @blur="emit"
      :checked="value"
      :true-value="1"
      :false-value="0"
      :required="required"
      @change="change"
    />
    <label :for="name" class="flex items-baseline cursor-pointer text-sm">
      <span
        class="flex justify-center items-center w-4 h-4 mr-3 rounded border border-grey overflow-hidden"
      >
        <span class="text-xs">
          <font-awesome-icon icon="check" size="xs"></font-awesome-icon>
        </span>
      </span>
      {{ label }}
      <div
        class="pl-2 pr-1 text-sm text-right text-blue-500 cursor-pointer"
        v-tooltip="labelInfo"
        v-if="hasHelp"
      >
        <font-awesome-icon icon="info-circle"></font-awesome-icon>
      </div>
    </label>
    <span class="help danger" v-if="withErrorMessage">
      <span
        v-if="useForm && $parent.form.errors.has(name)"
        v-text="$parent.form.errors.get(name)"
      ></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    labelInfo: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: Boolean,
    },
    required: {
      type: Boolean,
      default: false,
    },
    withErrorMessage: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {
    emit(ev) {
      this.$emit("input", ev.target.checked);
    },
    change() {
      if (this.useForm) {
        this.$parent.form.errors.clear(this.name);
      }
    },
  },
  computed: {
    useForm() {
      return this.$parent.form !== undefined && this.$parent.form.errors.has;
    },
    hasHelp() {
      return this.labelInfo != "" && this.labelInfo !== undefined;
    },
  },
  mounted() {},
};
</script>

<style></style>
